export default __webpack_public_path__ + "static/media/arrow_btn_back_dark.13a63d4e.svg";